import React, { useState, useEffect, useCallback } from 'react';
import { getModels } from '../services/adminStorage';
import ModelCard from './ModelCard';
import { ArrowRight, Sparkles } from 'lucide-react';

export default function RandomModelsSection({ onSelectModel, onGoToCatalog }) {
  const [randomModels, setRandomModels] = useState([]);

  const pickRandom = useCallback(() => {
    const all = getModels();
    const shuffled = [...all].sort(() => 0.5 - Math.random());
    setRandomModels(shuffled.slice(0, 6));
  }, []);

  useEffect(() => {
    pickRandom();
    const handleUpdate = () => pickRandom();
    window.addEventListener('suzume_data_updated', handleUpdate);
    return () => window.removeEventListener('suzume_data_updated', handleUpdate);
  }, [pickRandom]);

  return (
    <section className="section-padding" style={{ backgroundColor: '#ffffff' }}>
      <div className="container">
        <div style={{ marginBottom: '2.5rem' }}>
          <div className="badge badge-brand" style={{ marginBottom: '0.75rem' }}>
            <Sparkles size={14} />
            Destaques Aleatórios do Banco de Dados
          </div>
          <h2 style={{ fontSize: '2.25rem', color: 'var(--text-title)' }}>
            Modelos em Destaque
          </h2>
          <p style={{ color: 'var(--text-muted)', fontSize: '1rem', marginTop: '0.25rem' }}>
            A cada acesso, apresentamos 6 opções aleatórias do nosso acervo de landing pages.
          </p>
        </div>

        {/* Grid dos 6 cards aleatórios */}
        <div className="cards-grid">
          {randomModels.map((model) => (
            <ModelCard 
              key={model.id} 
              model={model} 
              onSelectModel={onSelectModel} 
            />
          ))}
        </div>

        {/* Botão Ver Catálogo Completo */}
        <div style={{ textAlign: 'center', marginTop: '3.5rem' }}>
          <button className="btn btn-primary btn-lg" onClick={onGoToCatalog}>
            Ver Catálogo Completo
            <ArrowRight size={20} />
          </button>
        </div>
      </div>
    </section>
  );
}
